module.exports = __webpack_public_path__ + "static/media/ios-moon.76319ae7.svg";